import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { ValidationButton } from '../../common/validation-button'
import React, { useState } from 'react'
import { DropzoneDialog } from 'material-ui-dropzone'
import getPayeService from '../../../api/envService'
import { useDispatch, useSelector } from 'react-redux'
import { completeUrl } from '../../../api/paye-service-api'

export const ImportExport = ({ classes, endpoint, reloadData }) => {
  const dispatch = useDispatch()
  const isModelisateur = useSelector(state => state.user.user.role === 'MODELISATEUR')
  const [openImportDiag, setOpenImportDiag] = useState(false)

  const handleExport = () => window.open(completeUrl(endpoint.endpoint) + '/export', '_blank')

  const handlePostFile = files => {
    if (files.length === 1) {
      setOpenImportDiag(false)
      getPayeService()
        .postFile(endpoint, files[0], 'dataFile', '/import')
        .then(() => dispatch(reloadData()))
    }
  }

  return (
    <>
      <Grid container direction="row" justify="flex-end" spacing={1}>
        <Grid item style={{ marginTop: 10 }}>
          <Button
            data-test="Nouveau Modèle de workflow"
            color="primary"
            variant="contained"
            size="medium"
            onClick={() => handleExport()}
            className={classes.margin}
          >
            exporter Tout
          </Button>
        </Grid>
        {isModelisateur && (
          <Grid item style={{ marginTop: 10 }}>
            <ValidationButton
              data-test="Nouveau Modèle de workflow"
              variant="contained"
              size="medium"
              onClick={() => setOpenImportDiag(true)}
              className={classes.margin}
            >
              importer
            </ValidationButton>
          </Grid>
        )}
      </Grid>
      <DropzoneDialog
        showAlerts={false}
        open={openImportDiag}
        onSave={handlePostFile}
        dropzoneClass="drop-zone"
        acceptedFiles={['application/json', '.json']}
        showPreviews={true}
        maxFileSize={5000000}
        onClose={() => setOpenImportDiag(false)}
        filesLimit={1}
        submitButtonText="Importer"
        cancelButtonText="Annuler"
      />
    </>
  )
}
